import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    FormControl,
    FormHelperText,
    Grid,
    Switch,
    TextField,
    Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';``
import { useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../api/axiosClient';
import Page from '../../components/Page';
import CustomChip from '../../components/mui/chip';
import { useGetInquiryQuery } from '../../store/inquiryApi';

const Inquiry = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [inquiry, setInquiry] = useState();
    const { refetch } = useGetInquiryQuery();
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm(); 

    useEffect(() => {
        apiService.get(`/inquiry/${params.id}`)
        .then(response => {
            const payload = response.data;
            setInquiry(payload.data)
            return payload.data.sku;
        })
        .catch(e => console.error(e));

    }, [params.id]);

    useEffect(() => {
        const defaultValues = {
            kind: inquiry?.kind,
            corpname: inquiry?.corpname,
            name: inquiry?.name,
            contact: inquiry?.contact,
            email: inquiry?.email,
            request: inquiry?.request,
            reply: inquiry?.reply,
            reply_text: inquiry?.reply_text,
            imageUrl1: inquiry?.imageUrl1,
            imageUrl2: inquiry?.imageUrl2,
            imageUrl3: inquiry?.imageUrl3,
            uptime: inquiry?.uptime,
        }
        reset(defaultValues)

    }, [reset, inquiry]);

    const goBack = () => {
        navigate(-1)
    }

    const sendTalk = async () => {
        if (!inquiry?.contact) {
            toast.error('연락처가 없습니다. 톡 발신을 할 수 없습니다.')
            return;
        }

        const params = {
            "userName": inquiry.username,
            "displayName": inquiry.name,
            "qnaValue": inquiry.request,
            "replayValue": inquiry.reply_text,
            "orderContact": inquiry.contact,
        };

        try {
            await apiService.post('/biztalk/reply', params);
            toast.success('주문자에게 Biztalk으로 알림이 발송되었습니다.');
        } catch (error) {
            console.error("Error sending reply notification:", error);
            toast.error('알림 발송에 실패했습니다. 다시 시도해주세요.');
        }
    }

    const onSubmit = async (data, e) => {
        const params = {
            "reply": data.reply,
            "reply_text": data.reply_text
        };

        await apiService.put(`/inquiry/${inquiry.qid}`, params)
        .then(response => {
            toast.success('수정 되었습니다')
            refetch();

            goBack();
        }).catch(error => {
            // 에러는 이제 axiosClient의 interceptor에서 자동으로 처리됩니다
            console.error('API Error:', error);
        })
    }

    const currencyLocale = Intl.NumberFormat('ko-KR');

    return (
        <Page title="빠른문의">
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} id="qform">
                    <CardContent sx={{ pt: 8 }}>
                        <Box sx={{ mb: 9, textAlign: 'center' }}>
                            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                문의
                            </Typography>
                        </Box>

                        <Grid container spacing={6}>
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kind'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                disabled
                                                value={value}
                                                label='문의유형'
                                                id='kind'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.kind)}
                                                aria-describedby='validation-async-kind'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='corpname'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                disabled
                                                value={value}
                                                label='법인명'
                                                id='corpname'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.corpname)}
                                                aria-describedby='validation-async-corpname'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='name'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                disabled
                                                value={value}
                                                label='이름'
                                                id='name'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.name)}
                                                aria-describedby='validation-async-name'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='contact'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                disabled
                                                value={value}
                                                label='연락처'
                                                id='contact'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.contact)}
                                                aria-describedby='validation-async-contact'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='email'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                disabled
                                                value={value}
                                                label='이메일'
                                                id='email'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.email)}
                                                aria-describedby='validation-async-email'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='request'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                disabled
                                                value={value}
                                                label='내용'
                                                id='request'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.request)}
                                                aria-describedby='validation-async-request'
                                                variant="standard"
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='reply_text'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='문의회신'
                                                id='reply_text'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.reply_text)}
                                                aria-describedby='validation-async-reply_text'
                                                variant="standard"
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                    name="reply"
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue="n"
                                    render={({ field: { value, onChange } }) => (
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Switch
                                                checked={value === 'y'} // Check if the value is 'Y'
                                                onChange={e => onChange(e.target.checked ? 'y' : 'n')} // Map boolean to 'Y' or 'N'
                                                inputProps={{ 'aria-label': 'Reply Switch' }}
                                            />
                                        <Typography sx={{ ml: 2 }}>회신 여부</Typography>
                                        </Box>
                                    )}
                                    />
                                    {errors.reply && (
                                    <FormHelperText sx={{ color: 'error.main' }} id="validation-async-reply">
                                        필수
                                    </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            
                            <Grid item xs={12}>
                                <CustomChip
                                    skin='light'
                                    color='info'
                                    label={`등록날짜: ${inquiry?.uptime}`}
                                    sx={{ '& .MuiChip-label': { color: 'common.black' } }}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </form>

                {['imageUrl1', 'imageUrl2', 'imageUrl3'].map((key, idx) => {
                    const url = inquiry?.[key];
                    if (!url) return null;

                    const isPdf = url.toLowerCase().endsWith('.pdf');
                    const fileName = url.split('/').pop();

                    return (
                        <Box key={key} sx={{ display: 'flex', justifyContent: 'left', margin: 4 }}>
                            {isPdf ? (
                                <a href={url} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    src="/images/icons/file-icons/pdf.png"
                                    alt={fileName}
                                    style={{ width: 40, height: 40, marginRight: 8 }}
                                />
                                <span>{decodeURIComponent(fileName)}</span>
                                </a>
                            ) : (
                                <img
                                src={url}
                                alt={`첨부 이미지 ${idx + 1}`}
                                style={{ maxWidth: '100%', height: 'auto' }}
                                />
                            )}
                        </Box>
                    );
                })}

                <CardActions className='card-action'>
                    <Button type="submit" form="qform" variant='contained'> 수정 </Button>
                    <Button variant='contained' color='warning' onClick={sendTalk}> 비즈톡 발신 </Button>
                    <Button variant='outlined' color='secondary' onClick={goBack}> 취소 </Button>
                </CardActions>
            </Card>
        </Page>
    )
}

export default Inquiry